import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { OrderDetailTitle } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import BackorderDatatable from 'src/common/components/orderDetails/detailsDataTable/backOrderDatatable/BackOrderDatatable';
import { setItemsDataHandler } from 'src/utils/util';
import { MobileView, DesktopView } from 'src/pages/orders/index';
import BackOrderSetContainer from 'src/common/components/orderDetails/backOrderDetails/backorderContainer/BackOrderSetContainer';
import BackOrderCards from 'src/common/components/orderDetails/backOrderDetails/backOrderCard/BackOrderCards';
import BackOrderCardContainer from 'src/common/components/orderDetails/backOrderDetails/backorderContainer/BackOrderCardContainer';
import {
    WrapperContainer,
    OrderDetailFooterContainer,
    InvoiceCreatedDetail,
} from './BackOrderDetails.styled';
import { getDisplayDate, getTimeZoneName } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';
import { convertTime24To12 } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const BackOrderDetails = ({ handleSetItemClick, ordersList }) => {
    const [nonSetItems, setNonSetItems] = useState([]);
    const [isSetItems, setIsSetItems] = useState([]);
    const [isSetItemsCount, setisSetItemsCount] = useState(0);
    const [modifyDate, setModifyDate] = useState('');
    const [modifyTime, setModifyTime] = useState('');
    const { t } = useTranslation();

    const { backOrders } = useSelector((state) => state.orderSummaryReducer);
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const setItemHandler = (data) => {
        const setItemDetails = setItemsDataHandler(data, ordersList);
        handleSetItemClick(setItemDetails);
    };
    const { orderBasicDetails, lastModifiedBy, lastModifiedDate } = useSelector(
        (state) => ({
            orderBasicDetails: state.orderSummaryReducer.orderBasicDetails,
            lastModifiedBy:
                state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                    ?.lastModifiedBy,
            lastModifiedDate:
                state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                    ?.lastModifiedDate,
        })
    );

    useEffectWithErrorLogging(() => {
        if (lastModifiedDate && lastModifiedDate !== '') {
            setModifyDate(
                getDisplayDate(new Date(lastModifiedDate), t('dateFormat'))
            );
            setModifyTime(convertTime24To12(new Date(lastModifiedDate)));
        }
    }, [lastModifiedDate]);

    useEffectWithErrorLogging(() => {
        if (backOrders && backOrders?.length && backOrders.length > 0) {
            const isNonItemInSet = backOrders.filter(
                (x) => !x?.isItemInSet && !x.isItemInSet
            );
            setNonSetItems(isNonItemInSet);

            const isItemInSet = backOrders.filter(
                (x) => x?.isItemInSet && x.isItemInSet
            );
            const isItemSetCount = isItemInSet
                ?.map((x) => {
                    return x.itemInSetList;
                })
                ?.reduce((accumulator, currentValue) => {
                    return [...accumulator, ...currentValue];
                }, []);

            setIsSetItems(isItemInSet);
            isItemSetCount?.length > 0 &&
                setisSetItemsCount(isItemSetCount.length);
        }
    }, [backOrders]);

    return (
        <>
            <MobileView>
                {nonSetItems &&
                nonSetItems?.length &&
                nonSetItems?.length > 0 ? (
                    <>
                        <OrderDetailTitle margin={'15px 0 16px 0'} isCondensedView={isCondensedView}>{`${t(
                            'orders.orderSummaryTabs.backorder'
                        )} (${nonSetItems.length})`}</OrderDetailTitle>
                        <BackOrderCardContainer
                            mobileContainerMargin={'0px'}
                            itemCount={nonSetItems.length}
                            paddingContainer={'15px 16px'}
                        >
                            <>
                                {nonSetItems?.map((data) => {
                                    return (
                                        <BackOrderCards
                                            key={data.cfn}
                                            data={data}
                                            setItemHandler={setItemHandler}
                                            ordersList={ordersList}
                                            isEquity={
                                                orderBasicDetails?.currentOrderType ===
                                                'ZOR'
                                            }
                                            textAlign={'left'}
                                        />
                                    );
                                })}
                            </>
                        </BackOrderCardContainer>
                    </>
                ) : null}
                {isSetItems && isSetItems?.length && isSetItems.length > 0 ? (
                    <>
                        <OrderDetailTitle margin={'15px 0 16px 0'}>{`${t(
                            'orders.orderSummaryTabs.backordersets'
                        )} (${isSetItemsCount})`}</OrderDetailTitle>
                        <BackOrderCardContainer
                            mobileContainerMargin={'0px'}
                            itemCount={isSetItems.length}
                            paddingContainer={'15px 16px'}
                        >
                            {isSetItems?.map((backorder) => {
                                return (
                                    <BackOrderSetContainer
                                        key={backorder.cfn}
                                        setDetailCfn={backorder.cfn}
                                        setDescription={backorder.description}
                                        setItemHandler={setItemHandler}
                                        setDetailsData={backorder}
                                        cardMargin={'0px 0 15px 0'}
                                        cardPadding={'15px 10px 10px 10px'}
                                    >
                                        {backorder?.itemInSetList &&
                                        backorder?.itemInSetList?.length &&
                                        backorder?.itemInSetList.length > 0 ? (
                                            <>
                                                {backorder?.itemInSetList.map(
                                                    (data) => {
                                                        return (
                                                            <BackOrderCards
                                                                key={data.cfn}
                                                                data={data}
                                                                setItemHandler={
                                                                    setItemHandler
                                                                }
                                                                ordersList={
                                                                    ordersList
                                                                }
                                                            />
                                                        );
                                                    }
                                                )}
                                            </>
                                        ) : null}
                                    </BackOrderSetContainer>
                                );
                            })}
                        </BackOrderCardContainer>
                    </>
                ) : null}
            </MobileView>
            <DesktopView>
                {nonSetItems &&
                nonSetItems?.length &&
                nonSetItems.length > 0 ? (
                    <>
                        <OrderDetailTitle margin={'15px 0 24px 0'}>{`${t(
                            'orders.orderSummaryTabs.backorder'
                        )}  (${nonSetItems.length})`}</OrderDetailTitle>
                        <BackorderDatatable
                            data={nonSetItems}
                            setItemHandler={setItemHandler}
                            ordersList={ordersList}
                            specificPadding={'0rem 2rem'}
                        />
                    </>
                ) : null}

                {isSetItems && isSetItems?.length && isSetItems.length > 0 ? (
                    <>
                        <OrderDetailTitle margin={'15px 0 16px 0'}>{`${t(
                            'orders.orderSummaryTabs.backordersets'
                        )} (${isSetItemsCount})`}</OrderDetailTitle>
                        {isSetItems?.map((backorder) => {
                            return (
                                <BackOrderSetContainer
                                    key={backorder.cfn}
                                    setDetailCfn={backorder.cfn}
                                    setDescription={backorder.description}
                                    setItemHandler={setItemHandler}
                                    setDetailsData={backorder}
                                    cardMargin={'0px 0 15px 0'}
                                    cardPadding={'15px 10px 10px 10px'}
                                >
                                    <BackorderDatatable
                                        data={backorder.itemInSetList}
                                        setItemHandler={setItemHandler}
                                        ordersList={ordersList}
                                    />
                                </BackOrderSetContainer>
                            );
                        })}
                    </>
                ) : null}
            </DesktopView>
            <OrderDetailFooterContainer>
                {lastModifiedBy || modifyDate || modifyTime ? (
                    <>
                        <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                            {isLanguageChanged && lastModifiedBy?'':t('orders.orderSummaryTabs.lastmodify')}
                        </InvoiceCreatedDetail>
                        {lastModifiedBy ? (
                            <>
                                <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                {isLanguageChanged ?t('orders.orderSummaryTabs.lastmodify'):t('orders.orderDetails.billingSummary.by')}

                                </InvoiceCreatedDetail>
                                <InvoiceCreatedDetail
                                    margin={'0 2px 0 0'}
                                    isCreatedDateBy
                                >
                                    {lastModifiedBy}
                                </InvoiceCreatedDetail>
                            </>
                        ) : null}
                        <WrapperContainer>
                            {modifyDate ? (
                                <InvoiceCreatedDetail margin={'0 2px 0 -1px'}>
                                    {modifyDate}
                                </InvoiceCreatedDetail>
                            ) : null}
                            {modifyTime ? (
                                <InvoiceCreatedDetail>
                                    {modifyTime} {getTimeZoneName()}
                                </InvoiceCreatedDetail>
                            ) : null}
                        </WrapperContainer>
                    </>
                ) : null}
            </OrderDetailFooterContainer>
        </>
    );
};

export default BackOrderDetails;
